<template>
  <v-card>
    <v-card-title class="text"
      >{{ question.literalNumber }} {{ question.question }}</v-card-title
    >
    <v-card-actions>
      <v-text-field
        label="respuesta"
        v-model="info"
        v-on:keyup="registerAnswer(questionNumber, info)"
        type="number"
        v-if="numeric"
        :disabled="disabled"
      ></v-text-field>
      <v-text-field
        label="respuesta"
        v-model="info"
        v-else
        :disabled="disabled"
        v-on:keyup="registerAnswer(questionNumber, info)"
      ></v-text-field>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      info: "",
    };
  },
  props: {
    question: Object,
    questionNumber: String,
    answer: String,
    numeric: Boolean,
    disabled: Boolean,
  },
  methods: {
    registerAnswer(number, answer) {
      this.$emit("selectAnswer", { number: number, answer: answer });
    },
  },
  mounted() {
    this.info = this.answer;
  },
};
</script>
<style scoped>
.text {
  word-break: normal;
}
</style>